import React, { lazy, Suspense } from 'react'
import { FormattedHTMLMessage } from '@web/walter-ui-kit'

import Preloader from './Preloader'
import styles from './style.module.css'
import PageHeader from '~components/PageLayout/PageHeader'
import { lang as navMenuLang } from '~components/App/Layout/NavigationMenu/lang'
import PageLayout from '~components/PageLayout'

const Content = lazy(() => import('./Content'))

function StakingPage() {
    return (
        <Suspense
            fallback={
                <PageLayout header={<PageHeader rootPage title={<FormattedHTMLMessage {...navMenuLang.staking} />} />}>
                    <div className={styles.content}>
                        <Preloader />
                    </div>
                </PageLayout>
            }
        >
            <Content />
        </Suspense>
    )
}

export default StakingPage
